var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-button",
        {
          staticStyle: { "margin-bottom": "10px" },
          attrs: { type: "primary", size: "small", icon: "el-icon-back" },
          on: {
            click: function($event) {
              return _vm.$router.back(-1)
            }
          }
        },
        [_vm._v("返回")]
      ),
      _c(
        "div",
        { staticClass: "box" },
        [
          _vm.showCheditor
            ? _c("Cheditor", {
                ref: "cheditor",
                attrs: { height: _vm.height + "px", width: "1000px" },
                on: { openDialog: _vm.openDialog },
                model: {
                  value: _vm.content,
                  callback: function($$v) {
                    _vm.content = $$v
                  },
                  expression: "content"
                }
              })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "console",
              style: { height: _vm.height + 75 + 29 + "px" }
            },
            [
              _c("div", { staticClass: "title" }, [_vm._v("模板信息")]),
              _c(
                "div",
                { staticClass: "console-body" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "templateForm",
                      staticClass: "demo-ruleForm",
                      attrs: {
                        model: _vm.templateData,
                        size: "small",
                        "label-position": "top",
                        rules: _vm.temRules,
                        "label-width": "100px"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "文书模板名称", prop: "templateName" }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.templateData.templateName,
                              callback: function($$v) {
                                _vm.$set(_vm.templateData, "templateName", $$v)
                              },
                              expression: "templateData.templateName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "公证文书类型", prop: "sheetNo" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                size: "small",
                                clearable: "",
                                placeholder: "请选择"
                              },
                              model: {
                                value: _vm.templateData.sheetNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.templateData, "sheetNo", $$v)
                                },
                                expression: "templateData.sheetNo"
                              }
                            },
                            _vm._l(_vm.typeOptions, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "addVar-btn",
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.temSubmitForm("templateForm")
                                }
                              }
                            },
                            [_vm._v("立即创建")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "addVar-btn",
                      attrs: { size: "small" },
                      on: { click: _vm.addVar }
                    },
                    [_vm._v("添加变量")]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "新增变量",
                visible: _vm.showDialog,
                "append-to-body": "",
                width: "500px"
              },
              on: {
                "update:visible": function($event) {
                  _vm.showDialog = $event
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    size: "small",
                    "label-width": "100px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "变量名称", prop: "varName" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.ruleForm.varName,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleForm, "varName", $$v)
                          },
                          expression: "ruleForm.varName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.submitForm("ruleForm")
                            }
                          }
                        },
                        [_vm._v("确定")]
                      ),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.showDialog = false
                            }
                          }
                        },
                        [_vm._v("取消")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }